import * as React from 'react';
import { _ as __rest, a as __assign } from './tslib.es6-21effb23.js';
import { c as classNames } from './index-29eed6c4.js';
import { A as ArrowThinRightIcon } from './ArrowThinRightIcon-dbe2d2c8.js';
import './countries-66cada71.js';
import { IconButton } from './es/components/IconButton.js';
import { S as SelectInput } from './index-fbf3ab0a.js';
import { Typography } from './es/components/Typography.js';

var ArrowThinLeftIcon = function (_a) {
    var _b = _a.fillColor, fillColor = _b === void 0 ? "currentColor" : _b, props = __rest(_a, ["fillColor"]);
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.81689 12C1.81689 11.2899 2.40788 10.7143 3.13689 10.7143H22.4969C23.2259 10.7143 23.8169 11.2899 23.8169 12C23.8169 12.7101 23.2259 13.2857 22.4969 13.2857H3.13689C2.40788 13.2857 1.81689 12.7101 1.81689 12Z", fill: fillColor }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9903 3.37658C12.5058 3.87868 12.5058 4.69275 11.9903 5.19485L5.00366 12L11.9903 18.8051C12.5058 19.3073 12.5058 20.1213 11.9903 20.6234C11.4748 21.1255 10.639 21.1255 10.1235 20.6234L2.20351 12.9091C1.68802 12.407 1.68802 11.593 2.20351 11.0909L10.1235 3.37658C10.639 2.87447 11.4748 2.87447 11.9903 3.37658Z", fill: fillColor })));
};

var styles = {"container":"Pagination_container_aa3bec0f","count":"Pagination_count_aa3bec0f"};

var PaginationContent = function (_a) {
    var pageIndex = _a.pageIndex, total = _a.total, perPage = _a.perPage, perPageOptions = _a.perPageOptions, onSelectPerPage = _a.onSelectPerPage, onNext = _a.onNext, onPrev = _a.onPrev, className = _a.className, label = _a.label, isSkeleton = _a.isSkeleton, otherProps = __rest(_a, ["pageIndex", "total", "perPage", "perPageOptions", "onSelectPerPage", "onNext", "onPrev", "className", "label", "isSkeleton"]);
    var start = (pageIndex - 1) * perPage;
    var end = Math.min(total, start + perPage);
    var selectOptions = perPageOptions.map(function (option) { return ({
        label: option,
        value: option,
    }); });
    return (React.createElement("div", __assign({ role: "navigation", "aria-busy": isSkeleton, "aria-label": label ? label : "Pagination", className: classNames(styles.container, className) }, otherProps),
        (isSkeleton || total > 0) && (React.createElement("div", { className: styles.count },
            React.createElement(Typography, { isSkeleton: isSkeleton, variant: "small", as: "p", "data-testid": "pagination-number-of-pages" },
                start + 1,
                " - ",
                end,
                " of ",
                total))),
        React.createElement(IconButton, { hasBorder: true, isSkeleton: isSkeleton, label: "Previous page", onClick: function () { return onPrev(); } },
            React.createElement(ArrowThinLeftIcon, null)),
        React.createElement(SelectInput, { id: "select-pagination-per-page", "data-testid": "select-pagination-per-page", label: label, showLabel: false, items: selectOptions, variant: "small", "aria-label": "Select per page", initialSelectedItem: { label: perPage + "", value: perPage + "" }, handleSelectedItemChange: function (selectedItem) {
                return selectedItem && onSelectPerPage(selectedItem.value);
            }, isSkeleton: isSkeleton, preferredPopoverPositions: ["bottom", "top"] }),
        React.createElement(IconButton, { hasBorder: true, isSkeleton: isSkeleton, label: "Next page", onClick: function () { return onNext(); } },
            React.createElement(ArrowThinRightIcon, null))));
};

/**
 * Clamp page index
 *
 * @param index - The desired page index
 * @param perPage - Amount of items per page
 * @param total - Total amount of items
 * @returns A valid page index between 0 and maximum page index
 */
function clampPageIndex(index, perPage, total) {
    var maxPage = Math.ceil(total / perPage);
    return Math.max(1, Math.min(maxPage, index));
}
var Pagination = function (_a) {
    var total = _a.total, perPage = _a.perPage, perPageOptions = _a.perPageOptions, pageIndex = _a.pageIndex, onUpdatePageIndex = _a.onUpdatePageIndex, onUpdatePerPage = _a.onUpdatePerPage, isSkeleton = _a.isSkeleton, label = _a.label;
    var handlePrev = function () {
        onUpdatePageIndex(clampPageIndex(pageIndex - 1, perPage, total));
    };
    var handleNext = function () {
        onUpdatePageIndex(clampPageIndex(pageIndex + 1, perPage, total));
    };
    var handleSelectPerPage = function (perPageValue) {
        onUpdatePerPage(+perPageValue);
        onUpdatePageIndex(clampPageIndex(pageIndex, +perPageValue, total));
    };
    return (React.createElement(PaginationContent, { onSelectPerPage: handleSelectPerPage, onPrev: handlePrev, onNext: handleNext, pageIndex: pageIndex, perPage: perPage, perPageOptions: perPageOptions.map(function (option) { return option + ""; }), total: total, isSkeleton: isSkeleton, label: label }));
};

export { ArrowThinLeftIcon as A, Pagination as P };
